export default "__VITE_ASSET__CP7S2Kw1__"